import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'CoreVirtualDeviceMonitoringCard',
  props: {
    id: {
      type: Number,
      required: true
    },
    account: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    devices: {
      type: [Number, String],
      default: 0
    },
    errors: {
      type: [Number, String],
      default: 0
    },
    warnings: {
      type: [Number, String],
      default: 0
    },
    tags: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    actions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    canDelete: function canDelete() {
      return this.actions.includes('delete');
    },
    // if feature-flag `rd-6855` is disabled, there still is an EDIT view, rather than just create
    canEdit: function canEdit() {
      return this.actions.includes('edit');
    }
  }),
  watch: {},
  methods: {
    openMonitoringView: function openMonitoringView(id, state) {
      this.$router.push("/virtual-device-groups/".concat(id, "?tab=").concat(state));
    },
    openMapview: function openMapview(id) {
      this.$router.push({
        path: '/virtual-device-groups/map',
        query: {
          view: id,
          mode: 'devices'
        }
      });
    },
    handleDelete: function handleDelete(event) {
      event.target.blur();
      this.$emit('delete', this.id);
    },
    // if feature-flag `rd-6855` is disabled, there still is an EDIT view, rather than just create
    handleEdit: function handleEdit(event) {
      event.target.blur();
      this.$emit('edit', this.id);
    }
  }
};